const FAQSTRIAL = [
  {
    id: 1,
    center: true,
    key: 1,
    title: 'Red Hat Learning Subscription Trial',
  },
  {
    id: 2,
    icon: 'Q1',
    class: 'faq-icon',
    key: 2,
    center: false,
    question: 'What is the duration of my Red Hat Learning Subscription Trial?',
    answer: [
      {
        key: 3,
        class: 'list-item',
        text: 'The trial has a duration of 90 days. ',
      },
    ],
  },
  {
    id: 3,
    icon: 'Q2',
    class: 'faq-icon',
    key: 4,
    center: false,
    question: 'Am I able to renew my Red Hat Learning Subscription Trial?',
    answer: [
      {
        key: 5,
        class: 'list-item',
        text: 'The trial is renewable on the Red Hat Product Trial Center.',
      },
      {
        key: 6,
        class: 'list-item',
        link: 'https://www.redhat.com/en/products/trials#app-dev-services',
      },
    ],
  },
  {
    id: 4,
    icon: 'Q3',
    class: 'faq-icon',
    key: 7,
    center: false,
    question: 'What is included with my Red Hat Learning Subscription Trial?',
    answer: [
      {
        key: 8,
        class: 'list-item',
        text: 'You have access to a set of courses specifically designed to teach foundational content across all Red Hat Product families. In addition, you also have access to all of the Technical Overview courses and a select set of Expert Extra videos. The Red Hat Learning Subscription features that are available to you also include Skills Paths, Reporting, Dashboards, and much more.',
      },
    ],
  },
  {
    id: 5,
    icon: 'Q4',
    class: 'faq-icon',
    key: 9,
    center: false,
    question:
      'How do I access courseware available in my Red Hat Learning Subscription Trial?',
    answer: [
      {
        key: 10,
        class: 'list-item',
        text: 'All trial courses are available directly from the Home page in the component labeled “Available in your trial subscription”. In addition, the Catalog also has a specific filter labeled “Trial subscription” that will filter the content available in your trial.',
      },
    ],
  },
  {
    id: 6,
    icon: 'Q5',
    class: 'faq-icon',
    key: 11,
    center: false,
    question:
      'Will new training courses or updated versions of existing training courses be available to me during the term of my subscription?',
    answer: [
      {
        key: 12,
        class: 'list-item',
        text: 'Yes. Trial courses will be updated as new Red Hat Product versions are released.',
      },
    ],
  },
  {
    id: 7,
    center: true,
    key: 13,
    title: 'Trial features',
  },
  {
    id: 8,
    icon: 'Q6',
    class: 'faq-icon',
    key: 14,
    center: false,
    question: 'Is lab time included with my trial?',
    answer: [
      {
        key: 15,
        class: 'list-item',
        text: 'No. The Red Hat Learning Subscription Trial does not include any lab hours. The trial courses will include Guided Exercises that include the steps you should take within the Red Hat product to complete the steps of each activity. Although the labs themselves are not available, each Guided Exercise will include a video of the instructor walking through the steps that are listed. Upgrade your subscription to gain access to Red Hat Training lab environments that build with the click of a button.',
      },
    ],
  },
  {
    id: 9,
    icon: 'Q7',
    class: 'faq-icon',
    center: false,
    key: 15,
    question: 'What are expert extras?',
    answer: [
      {
        key: 16,
        class: 'list-item',
        text: 'Expert extras are on-demand, high-definition videos that complement course content. These 8 to 15 minute videos are presented by Red Hat and expert practitioners as demos of innovative technologies and practices, based on real-world use cases and scenarios.',
      },
    ],
  },
  {
    id: 10,
    icon: 'Q8',
    class: 'faq-icon',
    key: 16,
    center: false,
    question: 'What is the Dashboard?',
    answer: [
      {
        key: 17,
        class: 'list-item',
        text: 'The dashboard delivers a convenient summary of your training progress and content consumption. The metrics help you track your growth and education throughout your learning journey. In addition to course progress, the dashboard also provides data about the amount of training content you have reviewed and the total time spent within the Red Hat Learning Subscription. You can download a report of these metrics to share with your manager.',
      },
    ],
  },
  {
    id: 11,
    icon: 'Q9',
    class: 'faq-icon',
    center: false,
    key: 18,
    question:
      'What determines if a self-paced training course is marked as complete?',
    answer: [
      {
        key: 19,
        class: 'list-item',
        text: 'A course or lesson is marked complete on the Dashboard and progress report when a user views 75% of it. The completion date reflects when this 75% threshold was reached.',
      },
    ],
  },
  {
    id: 12,
    icon: 'Q10',
    class: 'faq-icon',
    key: 20,
    center: false,
    question:
      'Which languages are Red Hat Learning Subscription Trial courses offered in?',
    answer: [
      {
        key: 21,
        class: 'list-item',
        text: 'All subscription content is available in English. Red Hat’s most popular courses are available in as many as eight languages: International Spanish, Brazilian Portuguese, French, Italian, German, Simplified Chinese, Korean, and Japanese. Red Hat cannot guarantee that a course will be published in another language.',
      },
    ],
  },
  {
    id: 13,
    icon: 'Q11',
    class: 'faq-icon',
    center: false,
    key: 22,
    question: 'Do the courses within the subscriptions have subtitles?',
    answer: [
      {
        key: 23,
        class: 'list-item',
        text: 'All course videos offer machine translated subtitles and transcripts in International Spanish, Brazilian Portuguese, French, Italian, German, Simplified Chinese, Korean, and Japanese.',
      },
    ],
  },
  {
    id: 14,
    center: true,
    key: 24,
    title: 'Support',
  },
  {
    id: 15,
    icon: 'Q12',
    class: 'faq-icon',
    key: 25,
    center: false,
    question:
      'How can I get support with my Red Hat Learning Subscription Trial?',
    answer: [
      {
        key: 26,
        class: 'list-item',
        text: 'Trial users will receive support through these FAQs, as well as tutorials and demos available within the Resource Center. Access all support materials by clicking the Support link in the top-left corner of your Red Hat Learning Subscription Trial.',
      },
    ],
  },
  {
    id: 16,
    icon: 'Q13',
    class: 'faq-icon',
    key: 27,
    center: false,
    question: 'Are trial courses available offline?',
    answer: [
      {
        key: 28,
        class: 'list-item',
        text: 'No. Trial users do not receive ebook access. Upgrade your subscription to utilize the Red Hat Training Bookshelf - an application that provides offline viewing of Red Hat Training course books.',
      },
    ],
  },
  {
    id: 17,
    center: true,
    key: 29,
    title: 'How to buy',
  },
  {
    id: 18,
    icon: 'Q14',
    class: 'faq-icon',
    key: 30,
    center: false,
    question: 'How can I upgrade my Red Hat Learning Subscription Trial?',
    answer: [
      {
        key: 31,
        class: 'list-item',
        text: 'Visit the How to buy page on redhat.com to learn about how to upgrade your Red Hat Learning Subscription.',
      },
      {
        key: 32,
        class: 'list-item',
        link: 'https://redhat.com/en/services/training/learning-subscription/how-to-buy',
      },
    ],
  },
  {
    id: 19,
    icon: 'Q15',
    class: 'faq-icon',
    key: 33,
    center: false,
    question: 'What is Red Hat Learning Subscription?',
    answer: [
      {
        key: 34,
        class: 'list-item',
        text: 'Red Hat Learning Subscription is a learning solution that provides users with one year of access to self-paced training courses. There are four subscriptions available for purchase that include additional features: premium , standard, basic, and developer. For each of these tiers, there is also an enterprise subscription package. Visit our Learning Subscription page to learn more.',
      },
      {
        key: 35,
        class: 'list-item',
        link: 'https://www.redhat.com/en/services/training/learning-subscription',
      },
    ],
  },
];

export default FAQSTRIAL;
